var render = function render(){var _vm=this,_c=_vm._self._c;return _c('judicial-recovery-enterprise-page',{attrs:{"nature":"Recuperação extrajudicial","back-to":"/recuperacao-extrajudicial"}})
}
var staticRenderFns = []

export { render, staticRenderFns }